import { initializeObservability } from "../observability";
import { load } from "./load";
import { InitOptions } from "./types";

export function init(opts: InitOptions) {
  try {
    load(opts);
    initializeObservability();
  } catch (error) {
    console.error("Failed to initialize analytics", error);
  }
}
